import { faChartNetwork } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Icon, Row, Tooltip, Typography } from "antd";
import React from "react";
import * as Assets from './../../assets';
var PageInformation = function (_a) {
    var prefixInfo = _a.prefixInfo, suffixInfo = _a.suffixInfo;
    var extraInfoIcons = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(Assets.Icons.InfoBars, null),
            React.createElement("span", { className: 'margin-left-xs' }),
            React.createElement(Assets.Icons.InfoPie, null));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: 'background-gray-1 padding-xs', align: 'middle', type: 'flex', style: { height: '36px', float: 'right', borderRadius: "6px", whiteSpace: 'nowrap' } },
            React.createElement(Col, { xs: 0, sm: 0, md: 0, lg: 0, xl: 24, xxl: 24, style: { whiteSpace: 'nowrap' } },
                extraInfoIcons(),
                React.createElement(Typography.Text, { ellipsis: true },
                    React.createElement(Icon, { className: "color-blue-5 margin-left-xs", component: function () { return React.createElement(FontAwesomeIcon, { icon: faChartNetwork }); } }),
                    React.createElement(Typography.Text, { strong: true, className: "margin-left-xs font-size-md" }, prefixInfo),
                    "\u00A0",
                    React.createElement(Typography.Text, { type: 'secondary', className: "font-size-md" }, suffixInfo))),
            React.createElement(Col, { xs: 24, sm: 24, md: 24, lg: 24, xl: 0, xxl: 0, className: 'no-padding no-margin' },
                extraInfoIcons(),
                React.createElement(Tooltip, { title: "".concat(prefixInfo, " ").concat(suffixInfo) },
                    React.createElement(Typography.Text, { ellipsis: true },
                        React.createElement(Icon, { className: "color-blue-5 margin-left-xs", component: function () { return React.createElement(FontAwesomeIcon, { icon: faChartNetwork }); } }),
                        React.createElement(Typography.Text, { strong: true, className: "margin-left-xs font-size-md" }, prefixInfo),
                        React.createElement(Typography.Text, { type: 'secondary', className: "font-size-md" }, " will...")))))));
};
export default PageInformation;
//# sourceMappingURL=index.js.map